// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-dots_loading__Ry98_","spacer":"loading-dots_spacer__Me41Y","blink":"loading-dots_blink__ATWnq","loading2":"loading-dots_loading2____Ssb"};